import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { BaseComponent } from 'src/app/common/base/base.component';
import { PrivilegeEnum } from 'src/app/common/enumerations/privilege-enum';
import { APLCategoryPopupComponent, APLCategoryPopupParameters } from './dialogs/apl-category-popup/apl-category-popup.component';
import { APLGroupRefresh } from '../store/apl-group/apl-group.action';
import { AplCategoryV2CategoriesComponent } from './apl-category-v2-categories/apl-category-v2-categories.component';

@Component({
  selector: 'app-apl-category-v2',
  templateUrl: './apl-category-v2.component.html',
  styleUrls: ['./apl-category-v2.component.scss']
})
export class APLCategoryV2Component extends BaseComponent implements OnInit, OnDestroy {
  @ViewChild('APLCategories') aplCategories!: AplCategoryV2CategoriesComponent;

  filter!: string;

  loading!: boolean;
  loadingMessage!: string;

  labelTitle!: string;
  labelCategories!: string;
  labelFilter!: string;

  enableMove = false;
  createCategoryPrivilege!: boolean;
  requestUserPrivilege!: boolean;

  ngOnInit(): void {
    this.store.dispatch(new APLGroupRefresh());
    this.createCategoryPrivilege = this.hasPrivilege(PrivilegeEnum.APLCategoryCreate);
    this.getPrivilege();
    this.setLabels();
  }

  applyFilter(filter: string) {
    this.filter = filter;
  }

  setLabels() {
    this.labelTitle = this.getMessage('APL_Category_AuthorizedPersonsAndTechnicalExperts')?.description;
    this.labelFilter = this.getMessage('APL_Category_Filter')?.description;
    this.labelCategories = this.getMessage('APL_CategorySidePanel_Categories')?.description;
    if (!this.labelTitle) {
      setTimeout(() => {
        this.setLabels();
      }, 500);
    }
  }

  getPrivilege() {
    if (!this.aplCategories?.aplCategories) {
      setTimeout(() => {
        this.getPrivilege();
      }, 500);
    }
    else {
      const isCategoryManager = this.aplCategories.aplCategories?.some(c => c.aplCategoryManagers?.some(m => m.userID == this.currentUser?.id));
      const isGroupManager = this.aplCategories.aplGroups?.some(g => g.aplGroupManagers?.some(m => m.userID == this.currentUser?.id));
      this.requestUserPrivilege = isCategoryManager || isGroupManager || this.hasPrivilege(PrivilegeEnum.APLCategoryEdit) || this.hasPrivilege(PrivilegeEnum.APLGroupEdit);
    }
  }

  create() {
    this.dialog.open(APLCategoryPopupComponent, {
      height: 'auto',
      width: '25vw',
      data: {
      } as APLCategoryPopupParameters,
    });
  }

  openLink(url: string) {
    window.open(url, '_blank');
  }

  setLoading(e: boolean) {
    setTimeout(() => {
      this.loading = e;
    }, 100);
  }
}
